import { Getters } from 'vuex-smart-module';
import PollsState from './state';

export default class PollsGetters extends Getters<PollsState> {}
